/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_HELP_OPTIONS_LIST = 'SET_HELP_OPTIONS_LIST';
export const SET_HELP_SELECTED_OPTION = 'SET_HELP_SELECTED_OPTION';
export const SET_HELP_PC_OPTIONS_LIST = 'SET_HELP_PC_OPTIONS_LIST';
export const SET_HELP_PC_SELECTED_OPTION = 'SET_HELP_PC_SELECTED_OPTION';
